import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import { useCallback, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import * as Yup from "yup";
import TextInput from "../../../../../components/formfields/InputField";
import { useDispatch, useSelector } from "react-redux";
import { addHomeDataAction } from "../actions";
import SubmitLoader from "../../../../../components/SubmitLoader";

const whatSchema = Yup.object({
  social_number_of_members: Yup.number().max(999, "Number of members should not be more than 999"),
});

const SocialSection = ({ props }: any) => {
  const [whatEdit, setWhatEdit] = useState<boolean>(false);
  const dispatch = useDispatch();
  const social_state = useSelector((state: any) => state?.home?.home_data);
  const [loading, setLoading] = useState(false);

  const whatState = {
    social_number_of_members: social_state?.social_number_of_members ? parseInt(social_state?.social_number_of_members) : "",
    social_static_line: social_state?.social_static_line ? social_state?.social_static_line : "",
    social_logo: social_state?.social_logo ? social_state?.social_logo : [],
  };
  const handleSocialSubmit = (values: any) => {
    setWhatEdit(false);
    let newArray = values?.social_logo?.map((obj: any) => {
      const { dummyImage, ...rest } = obj; // Using object destructuring to exclude the 'name' property
      return rest;
    });
    const form_data = new FormData();
    form_data.append("id", "social");
    form_data.append("social_number_of_members", values.social_number_of_members);
    form_data.append("social_static_line", values.social_static_line);
    form_data.append("social_logo", JSON.stringify(newArray));
    dispatch(addHomeDataAction(form_data, setWhatEdit, "add-social-section"));
  };

  // const handleUpload = (event: any, fieldValue: any, index: number, arrayHelpers: any) => {
  //   const name = `social_logo[${index}].image`;
  //   const data = {
  //     file: event.currentTarget.files[0],
  //   };
  //   if (event.currentTarget.files[0]) {
  //     arrayHelpers.push({ image: "" });
  //     props.uploadFileAction(data, fieldValue, name);
  //   }
  //   event.currentTarget.value = null;
  // };

  const handleUpload = (event: any, fieldValue: any, index: number, arrayHelpers: any) => {
    setLoading(true);
    const name = `social_logo[${index}].image`;
    const formData = new FormData();
    formData.append("file", event.currentTarget.files[0]);
    formData.append("folder", "home-page");
    formData.append("url", `single/${event.currentTarget.files[0]?.name}`);
    if (event.currentTarget.files[0]) {
      arrayHelpers.push({ image: "" });
      props.uploadFileNewAction(formData, fieldValue, name, setLoading);
    }
    // event.currentTarget.value = null;
  };

  const onImageChange = useCallback((event: any, fieldValue: any, index: number, arrayHelpers: any) => {
    if (event.target.files?.[0]) {
      const name = `social_logo[${index}].image`;
      const dummyImage = `social_logo[${index}].dummyImage`;
      const file = event.target.files[0];
      handleUpload(event, fieldValue, index, arrayHelpers);
      const URL = window.URL || window.webkitURL;
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = function handleImageLoad() {
        // fieldValue(name, event.target.files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          fieldValue(dummyImage, e?.target?.result);
        };
        reader?.readAsDataURL(event.target.files[0]);
      };
    }
  }, []);

  // const handleRemove = useCallback((field: string, dummyImage: string, fieldValue: any) => {
  //   fieldValue(field, "");
  //   fieldValue(dummyImage, "");
  // }, []);

  return (
    <Formik enableReinitialize initialValues={whatState} validationSchema={whatSchema} onSubmit={handleSocialSubmit}>
      {({ values, handleChange, handleBlur, setFieldValue, errors }) => {
        return (
          <Form autoComplete="off">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className={`mb-0 ${whatEdit ? "editTitle" : ""}`}>Social Section</h6>
                {whatEdit ? (
                  <button disabled={loading} type="submit" className="btn btn-primary">
                    <i className="fa-regular fa-floppy-disk"></i> Save
                  </button>
                ) : (
                  <span onClick={() => setWhatEdit(true)} className="btn btn-green">
                    <i className="fa-regular fa-pen-to-square"></i> Edit
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${whatEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                ></div>
                <Row className="gy-3">
                  <Col sm={4}>
                    <label className="form-label">Number of Member</label>
                    <Field
                      name="social_number_of_members"
                      component={TextInput}
                      type="number"
                      value={values.social_number_of_members}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Membership"
                      readOnly={!whatEdit}
                      className={whatEdit ? "editField" : ""}
                      min="0"
                    />
                  </Col>
                  <Col sm={8}>
                    <label className="form-label">Static Line</label>
                    <Field
                      name="social_static_line"
                      component={TextInput}
                      value={values.social_static_line}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Static line"
                      readOnly={!whatEdit}
                      className={whatEdit ? "editField" : ""}
                    />
                  </Col>
                  <Col>
                    <label className="form-label">Upload Company Logos</label>
                    <FieldArray
                      name="social_logo"
                      render={(arrayHelpers) => (
                        <>
                          <Row className="gy-3">
                            <Col sm={3}>
                              <div className="uploarForm square position-relative">
                                <input
                                  id="file"
                                  type="file"
                                  accept="image/x-png,image/gif,image/jpeg"
                                  onChange={(e) => onImageChange(e, setFieldValue, values.social_logo.length, arrayHelpers)}
                                  disabled={!whatEdit}
                                />
                                <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                                  <i className="fa-light fa-upload fa-2x text-primary"></i>
                                  <h6 className="mb-0 mt-3">Upload Images</h6>
                                </div>
                              </div>
                            </Col>

                            {values.social_logo.map((exp: any, index: number) => {
                              return (
                                <Col sm={3} key={exp?.image}>
                                  <div className="uploarForm square position-relative overflow-hidden">
                                    {(values.social_logo[index].dummyImage || values.social_logo[index].image) && (
                                      <>
                                        {values.social_logo[index].image ? (
                                          <>
                                            {whatEdit && (
                                              <a
                                                className="btn btn-danger btn-sm btn-icon position-absolute top-0 end-0 rounded me-2 mt-2 zindex-1"
                                                onClick={() => {
                                                  arrayHelpers.remove(index);
                                                }}
                                              >
                                                <i className="fa-regular fa-trash-can"></i>
                                              </a>
                                            )}

                                            <img
                                              className="position-absolute fitImage"
                                              src={values.social_logo[index].dummyImage || values.social_logo[index].image}
                                              alt="imagessss"
                                            />
                                          </>
                                        ) : (
                                          <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                                            <SubmitLoader />
                                          </div>
                                        )}
                                      </>
                                    )}

                                    <ErrorMessage name={`social_logo[${index}].image`} className="errorMessage" component="div" />
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                          {typeof errors.social_logo === "string" ? <p className="errorMsg">{errors.social_logo}</p> : null}
                        </>
                      )}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SocialSection;
